import { render } from "./Reset_pswd.vue?vue&type=template&id=5e7f9987&ts=true"
import script from "./Reset_pswd.vue?vue&type=script&lang=ts"
export * from "./Reset_pswd.vue?vue&type=script&lang=ts"

import "./Reset_pswd.vue?vue&type=style&index=0&id=5e7f9987&lang=scss"

import exportComponent from "F:\\200 Desarrollos\\SIE\\SIE-Publico\\SIE.Frontend\\WEB.Home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__